import { Injectable } from '@angular/core'
import { ProjectService } from '@app/data/service/project.service'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { forkJoin, of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import * as StageActions from './stage.actions'

@Injectable()
export class StageEffects {
   setProject$ = createEffect(() =>
      this.actions$.pipe(
         ofType(StageActions.setProject),
         switchMap((action) =>
            forkJoin([this._pmService.getById(action.projectId)]).pipe(
               map((project: any) => {
                  return StageActions.setProjectSuccess({ project })
               }),
               catchError((error) => of(StageActions.setProjectError({ error })))
            )
         )
      )
   )

   constructor(
      private actions$: Actions,
      private _pmService: ProjectService
   ) {}
}

